import { render, staticRenderFns } from "./DoKoDialogTablestats.vue?vue&type=template&id=4b0196c8&scoped=true&"
import script from "./DoKoDialogTablestats.vue?vue&type=script&lang=ts&"
export * from "./DoKoDialogTablestats.vue?vue&type=script&lang=ts&"
import style0 from "./DoKoDialogTablestats.vue?vue&type=style&index=0&id=4b0196c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0196c8",
  null
  
)

export default component.exports